import { get } from 'lodash';
import { RootState } from '../root-reducer';
export const userSelector = (state: RootState) => {
  return get(state, ['login', 'user', 'user']);
};
